import { apiFetch } from './client';

export const listSampleFiles = (systemId) => apiFetch(`/scans/sample-files?system_id=${systemId}`);

export const importScanFile = (systemId, filename) =>
  apiFetch(`/scans/import?system_id=${systemId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ filename }),
  });

export const uploadScanFile = (systemId, file) => {
  const form = new FormData();
  form.append('file', file);
  return apiFetch(`/scans/upload?system_id=${systemId}`, { method: 'POST', body: form });
};
